import { getAppEndpointVersion } from 'helpers'
import axios from './axiosInstance'
import constants from '../constants'

export default function init() {
}

// Helper function to append message filters to URL (DRY)
function appendMessageFilters(url, filters) {
  let result = url
  
  // Handle single sender
  if (filters.sender) {
    result += `&sender=${encodeURIComponent(filters.sender)}`
  }
  
  // Handle multiple senders
  if (filters.senders) {
    result += `&senders=${encodeURIComponent(filters.senders)}`
  }
  
  // Handle hasReactions filter
  if (filters.hasReactions !== undefined) {
    result += `&hasReactions=${encodeURIComponent(filters.hasReactions)}`
  }
  
  // Handle sentAt[from] filter
  if (filters.sentAtFrom) {
    result += `&sentAt[from]=${encodeURIComponent(filters.sentAtFrom)}`
  }
  
  // Handle sentAt[to] filter
  if (filters.sentAtTo) {
    result += `&sentAt[to]=${encodeURIComponent(filters.sentAtTo)}`
  }
  
  // Handle single type
  if (filters.type) {
    result += `&type=${encodeURIComponent(filters.type)}`
  }
  
  // Handle multiple types
  if (filters.types) {
    result += `&types=${encodeURIComponent(filters.types)}`
  }
  
  // Legacy support for old filter names (only if primary filter not set)
  if (filters.message_type && !filters.type) {
    result += `&type=${encodeURIComponent(filters.message_type)}`
  }
  if (filters.sender_uids && !filters.senders) {
    result += `&senders=${encodeURIComponent(filters.sender_uids)}`
  }
  
  // Handle date range filters
  if (filters.dateRangeFrom && filters.dateRangeTo) {
    result += `&dateRange[field]=sentAt&dateRange[from]=${encodeURIComponent(filters.dateRangeFrom)}&dateRange[to]=${encodeURIComponent(filters.dateRangeTo)}`
  } else if (filters.dateRangeFrom) {
    result += `&dateRange[field]=sentAt&dateRange[from]=${encodeURIComponent(filters.dateRangeFrom)}`
  } else if (filters.dateRangeTo) {
    result += `&dateRange[field]=sentAt&dateRange[to]=${encodeURIComponent(filters.dateRangeTo)}`
  }
  
  return result
}

export async function getAppMessages(app, apiHost, type = 'current', id = 0, filters = {}) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  const categories = filters.categories || 'custom,message,interactive,agentic'
  if (type === 'previous') {
    URL = `${URL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/messages?hideDeleted=1&limit=30&affix=prepend&id=${id}&categories=${categories}`
  } else if (type === 'next') {
    if (id > 0)
      URL = `${URL}${apiHost}/${getAppEndpointVersion(
        app,
      )}/messages?hideDeleted=1&limit=30&affix=append&id=${id}&categories=${categories}`
    else
      URL = `${URL}${apiHost}/${getAppEndpointVersion(
        app,
      )}/messages?hideDeleted=1&limit=30&categories=${categories}`
  } else {
    URL = `${URL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/messages?hideDeleted=1&limit=30&categories=${categories}`
  }
  
  URL = appendMessageFilters(URL, filters)
  
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function searchAppMessages(app, apiHost, fromDate, toDate, type = 'current', id = 0, filters = {}) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'

  URL = `${URL}${apiHost}/${getAppEndpointVersion(
    app,
  )}/messages?fromTimestamp=${fromDate}&toTimestamp=${toDate}&hideDeleted=1&limit=500&categories=${filters.categories || 'custom,message,interactive,agentic'}`
  if (type === 'previous') {
    URL = `${URL}&affix=prepend&id=${id}`
  }
  
  URL = appendMessageFilters(URL, filters)
  
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function exportAppMessages(app, apiHost, type = 'current', sentAt = 0, id = 0) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'

  if (type === 'previous') {
    URL = `${URL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/messages?sentAt=${sentAt}&hideDeleted=1&limit=1000&affix=prepend&id=${id}&categories=custom,message,interactive,agentic`
  } else {
    URL = `${URL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/messages?hideDeleted=1&limit=1000&categories=custom,message,interactive,agentic`
  }
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function getModerationMessages(app, apiHost, id = 0) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  if (id > 0)
    URL = `${URL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/users/app_system/messages?hideDeleted=1&per_page=50&category=custom&type=extension_human-moderation&affix=append&id=${id}`
  else
    URL = `${URL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/users/app_system/messages?hideDeleted=1&per_page=50&category=custom&type=extension_human-moderation&affix=append&id=0.5`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function deleteAppMessageLog(id, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/messages/${id}`
  return axios
    .delete(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function rejectModMessageLogs(message, app) {
  // PTM ADD THE URL
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}human-moderation-${app.region}.cometchat.io/v1/reject`
  // change the headers
  return axios
    .post(`${URL}`, message, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatAPIVersion: getAppEndpointVersion(app),
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}

export async function approveModMessageLogs(message, app) {
  // PTM ADD THE URL
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}human-moderation-${app.region}.cometchat.io/v1/approve`
  return axios
    .post(`${URL}`, message, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatAPIVersion: getAppEndpointVersion(app),
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}

export async function add(payload, id, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users/${id}/messages`
  return axios
    .post(`${URL}`, payload, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function getGroupMessages(app, guid = 0) {
  const URL = `${constants.customerDomain}groups/${guid}/messages?hideDeleted=1&limit=100`
  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function deleteGroupMessageLog(id, app) {
  const URL = `${constants.customerDomain}messages/159552124900000001`
  return axios
    .delete(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function getAppMessageByID(id, app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'

  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/messages/${id}`

  return axios
    .get(`${URL}`, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function getUserMessages(app, apiHost, userUid, onBehalfOfUid, params = {}) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  const query = Object.keys(params)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join('&')
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users/${encodeURIComponent(
    userUid,
  )}/messages${query ? `?${query}` : ''}`
  const headers = {
    appId: app.id,
    apiKey: app.accessKey,
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }
  if (onBehalfOfUid) headers.onBehalfOf = onBehalfOfUid

  return axios
    .get(`${URL}`, {
      headers,
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response?.data || { error: 'Failed to fetch user messages' }
    })
}

export async function getMessages(app, apiHost, params = {}, onBehalfOfUid) {
  // params: object with query params like perPage, limit, fromTimestamp, toTimestamp, etc.
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  const withTs = { ...params, ts: Date.now() }
  const query = Object.keys(withTs)
    .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(withTs[k])}`)
    .join('&')
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/messages${query ? `?${query}` : ''}`
  const headers = {
    appId: app.id,
    apiKey: app.accessKey,
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }
  if (onBehalfOfUid) headers.onBehalfOf = onBehalfOfUid

  return axios
    .get(`${URL}`, {
      headers,
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response?.data || { error: 'Failed to fetch messages' }
    })
}

export async function getMessageCategories(app, apiHost) {
  let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
  URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/messageCategories`

  try {
    const response = await axios.get(URL, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
    return response.data
  } catch (error) {
    return error?.response?.data || { error: 'Failed to fetch message categories' }
  }
}
